import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import BackToTop from "./elements/back-top";
import PageScrollTop from "./elements/page-scroll-top";
import Index3 from "./pages/index-3";
import About1 from "./pages/about-1";
import Photos from "./pages/photos";
import Videos from "./pages/videos";
import News0 from "./pages/news-0";
import News4 from "./pages/news-4";
import News6 from "./pages/news-6";
import News7 from "./pages/news-7";
import News10 from "./pages/news-10";
import News11 from "./pages/news-11";
import News12 from "./pages/news-12";
import IOAIIntroduction from "./pages/ioai-introduction";
import IOAIResource from "./pages/ioai-resource";
import IOAIApplication from "./pages/ioai-application";
import IOAIJourney from "./pages/ioai-journey";
import AOAITeam from "./pages/aoai-team";
import IOAISponsor from "./pages/aoai-sponsor";
import RoboticsForGoodIntroduction from "./pages/robotics-for-good-introduction";
import RoboticsForGoodApplication from "./pages/robotics-for-good-application";
import RoboticsForGoodJourney from "./pages/robotics-for-good-journey";
import RoboticsForGoodPartners from "./pages/robotics-for-good-partners";
import Contact2 from "./pages/contact-2";


class Markup extends Component {
	componentDidMount() {
		
	} 
	render() {
		return (
			<>
				<BrowserRouter basename={"/"}>
					<Switch>
						<Route path="/" exact component={Index3} />
						<Route path="/news-0" exact component={News0} />
						<Route path="/news-4" exact component={News4} />
						<Route path="/news-6" exact component={News6} />
						<Route path="/news-7" exact component={News7} />
						<Route path="/news-10" exact component={News10} />
						<Route path="/news-11" exact component={News11} />
						<Route path="/news-12" exact component={News12} />
						<Route path="/ioai-introduction" exact component={IOAIIntroduction} />
						<Route path="/ioai-resource" exact component={IOAIResource} />
						<Route path="/aoai-sponsor" exact component={IOAISponsor} />
						<Route path="/ioai-application" exact component={IOAIApplication} />
						<Route path="/ioai-journey" exact component={IOAIJourney} />
						<Route path="/aoai-team" exact component={AOAITeam} />
						<Route path="/robotics-for-good-introduction" exact component={RoboticsForGoodIntroduction} />
						<Route path="/robotics-for-good-application" exact component={RoboticsForGoodApplication} />
						<Route path="/robotics-for-good-journey" exact component={RoboticsForGoodJourney} />
						<Route path="/robotics-for-good-partners" exact component={RoboticsForGoodPartners} />
						<Route path="/photos" exact component={Photos} />
						<Route path="/videos" exact component={Videos} />
						<Route path="/about" exact component={About1} />
						<Route path="/contact" exact component={Contact2} />
					</Switch>		
					<div className="section-area section-sp3">
						<div className="col-md-12 heading-bx style1 text-center">
							<b>© Australian AI Olympiad Incorporated</b>
							<br/>
							All right reserved
						</div>
					</div>
					<PageScrollTop />
				</BrowserRouter>
				<BackToTop />
			</>
		);
	}
}

export default Markup;
